import { createAPI } from '@common'
export default {
  // 媒资推送-推送
  postMedialPush: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nfejbQvti0qvti', 'post', config),
  // 媒资推送-获取分组
  getMediaGroups: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nfejbQvti0hspvq', 'get', config, vconfig),
  // 媒资推送-获取推送第三方名称
  getMedialPushCompany: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nfejbQvti0dpnqboz', 'get', config),
}